export function metricsDTO(data) {
    const metricsData = {
        rank: data?.rank || "",
        completedMeetings: data?.completedMeetings || 0,
        region: data?.region?.name || "",
    }
    return metricsData;
};